export default "__VITE_ASSET__d72b441e__"